import React, { memo, useEffect, useState } from "react";

import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import PrivateRoute from "./routes/PrivateRoute";
import AdminRoute from "./routes/AdminRoute";
import PublishingRoute from "./routes/PublishingRoute";
import CopyrightRoute from "./routes/CopyrightRoute";
import LicensorsRoute from "./routes/LicensorsRoute";
import ResearcherRoute from "./routes/ResearcherRoute";
import GalleriesRoute from "./routes/GalleriesRoute";

import { Suspense } from "react";

import Header from "./components/Header/Header.jsx";
import Footer from "./components/Footer/Footer.jsx";

import {
  NotFoundPageAsync,
  AdminPageAsync,
  ContactPageAsync,
  FormInfoPageAsync,
  HomePageAsync,
  LibraryPageAsync,
  LicensorPageAsync,
  LoginPageAsync,
  PermissionNonExclusivePageAsync,
  PermissionNonExclusiveRusPageAsync,
  PrivatePolicyPageAsync,
  PublishingPageAsync,
  QuestionnairePageAsync,
  ResearcherPageAsync,
  CompanyPageAsync,
  StringerPageAsync,
  SubmitVideoPageAsync,
  SubmitVideoRefPageAsync,
  SubmitVideoRefPaidPageAsync,
  TeamPageAsync,
  TermsOfUsePageAsync,
  VideoPageAsync,
  CompletedAgreementPageAsync,
  ShareVideoAccessPageAsync,
  UploadAdditionalVideosPageAsync,
  CopyrightRequestPageAsync,
  SubmittedVideoRedirectPageAsync,
  WhitelistPageAsync,
  ContractPageAsync,
  UGCProductionPageAsync,
  LicenseAgreementPageAsync,
  TrustCenterPageAsync,
  ForMediaPageAsync,
  ApiPageAsync,
  AccountPageAsync,
  ClientInvitePageAsync,
  InvoicePageAsync,
  ReleasePageAsync,
  AgreementViewPageAsync,
  ReleaseRequestPageAsync,
  LicenceDealPageAsync,
  UnsubscribePageAsync,
  ResetPasswordPageAsync,
} from "./pages/index.jsx";

import "./styles/common.scss";

import AppLoader from "./shared/ui/AppLoader";
import ApiStatus from "./shared/ui/ApiStatus";
import axiosInstance from "./api/axios.instance";
import UseAvatar from "./shared/lib/hooks/useRandomAvatar.jsx";
import VideoCompilationModal from "./shared/ui/VideoCompilationModal";
import { useDispatch } from "react-redux";
import { actions } from "./redux/index.js";
import { SendVideosPage as SendVideosPageAsync } from "./pages/SendVideosPage/SendVideosPageAsync";
import { GalleriesPage as GalleriesPageAsync } from "./pages/GalleriesPage/GalleriesPageAsync";

const App = memo(() => {
  const [currentUser, setCurrentUser] = useState(null);
  const [randomAvatar, setRandomAvatar] = useState(null);

  const { avatarPath } = UseAvatar();
  const dispatch = useDispatch();

  useEffect(() => {
    try {
     // dispatch(actions.user.authenticate())
    } catch (error) {
      console.log(error.message);
    }

    (async () => {
      try {
        const { data } = await axiosInstance.post("/auth/authenticate");

        if (data.status === "success") {
          setCurrentUser(data.apiData);
          // TODO: добавил юзера в redux, в дальнейшем использовать оттуда
          // И ПЕРЕДЕЛАТЬ ВСЕ ПРОПСЫ НА redux
          dispatch(actions.user.setCurrentUser(data.apiData));

          setRandomAvatar(avatarPath);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  return (
    <div className="wrapper">
      <Header
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        randomAvatar={randomAvatar}
      />
      <section className="mainBlock">
        <ApiStatus />
        <Suspense fallback={<AppLoader />}>
          <Switch>
            <Route exact path="/" component={HomePageAsync} />

            <Route exact path="/aboutUs" component={TeamPageAsync} />
            <Route exact path="/contactUs" component={ContactPageAsync} />

            <Route exact path="/submitVideo" component={SubmitVideoPageAsync} />
            <Route
              exact
              path="/submitVideo/:name"
              component={SubmitVideoRefPageAsync}
            />
            <Route
              exact
              path="/submitVideos/:refHash"
              component={SubmitVideoRefPaidPageAsync}
            />

            <Route
              exact
              path="/privatePolicy"
              component={PrivatePolicyPageAsync}
            />
            <Route exact path="/termsOfUse" component={TermsOfUsePageAsync} />
            <Route
              exact
              path="/permission"
              component={PermissionNonExclusivePageAsync}
            />
            <Route
              exact
              path="/completedAgreement"
              component={CompletedAgreementPageAsync}
            />
            <Route
              exact
              path="/permissionRus"
              component={PermissionNonExclusiveRusPageAsync}
            />

            <PublishingRoute
              path="/publishing"
              exact={true}
              component={PublishingPageAsync}
            />

            <PrivateRoute
              path="/adding"
              exact={true}
              component={VideoCompilationModal}
            />

            <PrivateRoute
              path="/stringer"
              exact={true}
              component={StringerPageAsync}
            />

            <AdminRoute
              path="/admin"
              exact={true}
              component={AdminPageAsync}
            />

            <ResearcherRoute
              path={"/researcher"}
              exact={true}
              component={ResearcherPageAsync}
            />

            <PrivateRoute
              path={"/company"}
              exact={true}
              component={CompanyPageAsync}
            />

            <LicensorsRoute
              path="/licensors"
              exact={true}
              component={LicensorPageAsync}
            />

            <Route 
              exact 
              path="/library" 
              render={() => (
                <Suspense fallback={<></>}>
                  <LibraryPageAsync />
                </Suspense>
              )} 
            />

            <PrivateRoute
              path="/videoLink/:shareId"
              exact={true}
              component={ShareVideoAccessPageAsync}
            />

            <PrivateRoute
              path="/formInfo/:vbCode"
              exact={true}
              component={FormInfoPageAsync}
            />

            <CopyrightRoute
              path="/copyrightRequest"
              exact={true}
              component={CopyrightRequestPageAsync}
            />

            {/* channels to whitelist (same roles as copyright requests) */}
            <CopyrightRoute path="/whitelisting" exact={true} component={WhitelistPageAsync} />

            <Route
              exact
              path="/login"
              render={() => (
                <LoginPageAsync
                  setCurrentUser={setCurrentUser}
                  setRandomAvatar={setRandomAvatar}
                />
              )}
            />

            <Route
              exact
              path="/questionnaire"
              component={QuestionnairePageAsync}
            />
            <Route exact path="/trust" component={TrustCenterPageAsync} />
            <Route exact path="/for-media" component={ForMediaPageAsync} />
            <Route exact path="/api" component={ApiPageAsync} />

            {/* client (buyer) account — before /library/:id */}
            <Route exact path="/library/account" component={AccountPageAsync} />
            <Route exact path="/library/invite" component={ClientInvitePageAsync} />
            <Redirect exact from="/library/clients" to="/admin?sec=clients" />
            <Route exact path="/library/reset-password" component={ResetPasswordPageAsync} />
            <Route exact path="/library/account/invoices/:invoiceId" component={InvoicePageAsync} />
            <Route exact path="/library/clients/invoices/:invoiceId" component={InvoicePageAsync} />
            <Route exact path="/invoice/:token" component={InvoicePageAsync} />
            <Route exact path="/release/:token" component={ReleasePageAsync} />
            {/* a researcher signs the contractor agreement an admin sent */}
            <Route exact path="/contract/:token" component={ContractPageAsync} />
            <Route exact path="/agreement/:formId" component={AgreementViewPageAsync} />
            <Route exact path="/release-request/:token" component={ReleaseRequestPageAsync} />
            <Route exact path="/licence/:token" component={LicenceDealPageAsync} />
            <Route exact path="/licence/:token/invoice" component={InvoicePageAsync} />
            <Route exact path="/unsubscribe/:token" component={UnsubscribePageAsync} />
            <Route exact path="/library/:id/:slug?" component={VideoPageAsync} />

            <Route
              exact
              path="/uploadVideos/:vbCode/:uniqueId"
              component={UploadAdditionalVideosPageAsync}
            />
            {/* the author sends more videos of a pipeline card (link from the team) */}
            <Route exact path="/send/:token" component={SendVideosPageAsync} />
            {/* MSN photo galleries (delivered through VideoElephant) */}
            <GalleriesRoute exact path="/galleries" component={GalleriesPageAsync} />

            <Route
              exact
              path="/submittedVideo/:shortCode"
              component={SubmittedVideoRedirectPageAsync}
            />

            <Route
              exact
              path="/ugc-production"
              component={UGCProductionPageAsync}
            />

            <Route
              exact
              path="/licenseAgreement"
              component={LicenseAgreementPageAsync}
            />

            {/* Redirect /termsOfUsePayment → /termsOfUse to avoid duplicate content */}
            <Redirect from="/termsOfUsePayment" to="/termsOfUse" />
            <Route exact path="*" component={NotFoundPageAsync} />
          </Switch>
        </Suspense>
      </section>
      <section className="footerBlock">
        <Footer />
      </section>
    </div>
  );
});

export default withRouter(App);
